import styled from 'styled-components';

export const SectionGray = styled.div`
    background-color: #F3F5F9;
    padding: 30px 0;

    @media (min-width: 992px) {
        padding: 60px 0;
    }
`;

export const RelatedTitle = styled.div`
    margin-bottom: 12px;

    @media (min-width: 768px) {
        margin-bottom: 18px;
    }

    @media (min-width: 1200px) {
        margin-bottom: 30px;
    }
`;



// WEBPACK FOOTER //
// ./assets/js/styles/TemplatePage.ts